<dacks-content padding="none">
  <router-outlet></router-outlet>

  <footer-spacing type="content" />
</dacks-content>

